module.exports = __webpack_public_path__ + "img/qrcode.c7256055.webp";